import { Form } from 'antd';
import ExportDataForm from 'src/app/forms/ExportData/ExportDataForm';
import { checkPermission } from 'src/app/helpers/permission.helper';
import usePermissions from 'src/app/hooks/usePermissions';
import { routes } from 'src/configs/permissions.dictionary';

function SystemLogsPage() {
  const [form] = Form.useForm();
  const { permissions } = usePermissions();

  return (
    <div style={{ width: '35vw' }}>
      <ExportDataForm
        form={form}
        saveButtonDisabled={!checkPermission(permissions, [routes['/Portal'], 'SystemLogs', 'export'])}
      />
    </div>
  );
}

export default SystemLogsPage;
